"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _dentalProductApi = require("@/api/dentalProductApi");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'DistributorBinding',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    productId: {
      type: Number,
      default: null
    },
    selectedDistributorIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      listLoading: false,
      searchForm: {
        page: 1,
        limit: 10,
        keyword: ''
      },
      distributorList: [],
      total: 0,
      selectedDistributors: []
    };
  },
  watch: {
    visible: function visible(val) {
      this.dialogVisible = val;
      if (val) {
        this.getList();
      }
    },
    selectedDistributorIds: {
      handler: function handler(val) {
        this.selectedDistributors = val;
      },
      immediate: true
    }
  },
  methods: {
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      var params = {
        page: this.searchForm.page,
        limit: this.searchForm.limit,
        keyword: this.searchForm.keyword
      };
      (0, _dentalProductApi.getDistributorList)(params).then(function (res) {
        _this.distributorList = res || [];
        _this.total = res.length || 0;

        // 预选已绑定的分销商
        _this.$nextTick(function () {
          if (_this.selectedDistributorIds && _this.selectedDistributorIds.length > 0) {
            _this.distributorList.forEach(function (row) {
              if (_this.selectedDistributorIds.includes(row.id)) {
                _this.$refs.table.toggleRowSelection(row, true);
              }
            });
          }
        });
      }).finally(function () {
        _this.listLoading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.getList();
    },
    resetSearch: function resetSearch() {
      this.searchForm.keyword = '';
      this.searchForm.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.searchForm.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.selectedDistributors = val.map(function (item) {
        return item.id;
      });
    },
    handleClose: function handleClose() {
      this.$emit('update:visible', false);
    },
    confirmBinding: function confirmBinding() {
      this.$emit('confirm', this.selectedDistributors);
      this.handleClose();
    }
  }
};